import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ac817d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header border-0"
}
const _hoisted_4 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_5 = {
  key: 0,
  class: "p-1"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close close-button",
  "data-bs-dismiss": "modal"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body h-100" }
const _hoisted_9 = {
  key: 1,
  class: "modal-footer border-0"
}
const _hoisted_10 = {
  key: 0,
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", [
      _ctx.modalXxl ? 'custom-modal-90' : '',
      _ctx.modalLg ? 'modal-lg' : '',
      _ctx.modalMd ? 'modal-md' : '',
    ]]),
    id: "exampleModal",
    tabindex: "-1",
    ref: "modalEle"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (!_ctx.hideHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
              (!_ctx.hideCloseButton)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "body", {}, undefined, true)
        ]),
        (!_ctx.hideFooter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true),
              (!_ctx.hideCloseButton)
                ? (_openBlock(), _createElementBlock("button", _hoisted_10, " Close "))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}